import React from "react";
import { Alert } from "./Alert";

export function OfflineNotice() {
  return (
    <div className="px-4 pt-4">
      <Alert
        variant="info"
        size="small"
        title="Unable to connect to Cashboard. Check your network and try again."
      />
    </div>
  );
}
